import { IAppSettings, ISelectedTax } from '../types';
import fetchAPI from '../utils/fetchAPI';

interface IArgs {
	selectedTax: ISelectedTax;
	searchQuery?: string;
	selectedPostType?: string;
}

const getPosts = async (settings: IAppSettings, args: IArgs, page = 1) => {
	const effectivePostType =
		settings.multiPostType && args.selectedPostType ? args.selectedPostType : settings.postType;
	let url = `${settings.apiBase}/get-posts?post_type=${effectivePostType}&posts_per_page=${settings.postsPerPage}&paged=${page}&blog_id=${settings.blogId}`;
	Object.entries(args.selectedTax).forEach(([tax, term]) => {
		url += `&tax[${tax}]=${term}`;
	});

	if (args.searchQuery) {
		url += `&s=${args.searchQuery}`;
	}

	if (settings.postAuthor) {
		url += `&author=${settings.postAuthor}`;
	}

	return await fetchAPI(url);
};

export default getPosts;
